var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlackArrow = function SvgBlackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.665 7.2a1.128 1.128 0 0 1 0 1.604l-5.713 5.664a1.151 1.151 0 0 1-1.617 0 1.128 1.128 0 0 1 0-1.604L9.24 8 4.338 3.136a1.128 1.128 0 0 1 0-1.604 1.151 1.151 0 0 1 1.618 0l5.713 5.665-.004.003Z",
    fill: "#000"
  })));
};
export default SvgBlackArrow;